"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var useRichTextAudio = function useRichTextAudio(formattedDangerouslySetInnerHTML, richTextId) {
  var handleButtonClick = function handleButtonClick(event) {
    event.preventDefault();
    if (window.richTextAudio.src === event.currentTarget.getAttribute('data-audio-src')) {
      if (event.currentTarget.classList.contains('playing')) {
        event.currentTarget.classList.remove('playing');
        window.richTextAudio.pause();
      } else {
        event.currentTarget.classList.add('playing');
        window.richTextAudio.play();
      }
    } else {
      // switch to new audio file
      window.richTextAudio.src = event.currentTarget.getAttribute('data-audio-src');
      document.querySelectorAll("button.rich-text-audio-button").forEach(function (el) {
        el.classList.remove('playing');
      });
      event.currentTarget.classList.add('playing');
      window.richTextAudio.play();
    }
  };
  var handleAudioEnded = function handleAudioEnded(event) {
    var _document$querySelect, _document$querySelect2;
    (_document$querySelect = document.querySelector("[data-audio-src=\"".concat(event.target.src, "\"]"))) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.classList) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.remove('playing');
  };
  (0, _react.useEffect)(function () {
    window.richTextAudio = new Audio();
    window.richTextAudio.addEventListener('ended', handleAudioEnded);
    document.querySelectorAll("[data-short-id=\"".concat(richTextId, "\"] button.rich-text-audio-button")).forEach(function (el) {
      el.addEventListener('click', handleButtonClick);
    });
    return function () {
      window.richTextAudio.removeEventListener('ended', handleAudioEnded);
      document.querySelectorAll("[data-short-id=\"".concat(richTextId, "\"] button.rich-text-audio-button")).forEach(function (el) {
        el.removeEventListener('click', handleButtonClick);
      });
    };
  }, [formattedDangerouslySetInnerHTML]);
};
var _default = useRichTextAudio;
exports.default = _default;